#import "../fragments/stageset-basic.graphql"

mutation CreateBlankStageset($stageset: CreateStagesetInputFieldInput!) {
    createStageset(input: {stageset: $stageset}) {
        stageset {
            ...StagesetBasic
        }
    }
}
